import { inject, injectable } from 'inversify';
import { TYPES } from '@/engine/ioc';

import * as DT from '@/surgeries/cardiac/TTVR/TTVRDataTypes';

import { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm.ts';

@injectable()
export class CustomCommissurePointsDescriptorResolver {
  private readonly _descriptorPreffix = 'custom_cp_';

  private readonly _planningAlgorithm: PlanningAlgorithm;

  public constructor(
    @inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm
  ) {
    this._planningAlgorithm = planningAlgorithm;
  }

  public resolveCommissurePointDescriptor(): string {
    const commissureList = this._planningAlgorithm.getValueStrict('available_commissure_points', DT.IdentifiersList);
    const customDescriptors: Array<string> = commissureList.value.filter((descriptor) =>
      descriptor.includes(this._descriptorPreffix)
    );

    return this._descriptorPreffix + (this._defineCustomDescriptorSuffix(customDescriptors));
  }

  public getCommissurePointNumber(descriptor: string): number {
    return Number(descriptor.replace(this._descriptorPreffix, ''));
  }

  private _defineCustomDescriptorSuffix(customDescriptors: Array<string>): number {
    if (customDescriptors.length === 0 || customDescriptors[0].includes('2')) {
      return 1;
    }

    return 2;
  }
}
